import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {IPostOurOfferPayload} from "../types/IPostOurOfferPayload";

interface IOurOffer {
    name: string;
    email: string;
    company: string;
    phone: string;
    text: string;
    variant: number;
}

export const postOurOfferApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postOurOffer: build.mutation<IOurOffer, IPostOurOfferPayload>({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                try {
                    const payload = await appendTurnstileToken(body, TurnstileAction.OUR_OFFER_CONTACT);
                    const result = await baseQuery({
                        url: apiPath.our_offer,
                        method: "POST",
                        body: payload
                    });

                    if (result.error) {
                        return {error: result.error};
                    }

                    return {data: result.data as IOurOffer};
                } catch (_error) {
                    return {error: createTurnstileRtkError()};
                }
            }
        })
    })
});

export const {postOurOffer} = postOurOfferApi.endpoints;
export const {usePostOurOfferMutation} = postOurOfferApi;
import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import {IPostOurOfferPayload} from "../types/IPostOurOfferPayload";

interface IOurOffer {
    name: string;
    email: string;
    company: string;
    phone: string;
    text: string;
    variant: number;
}

export const postOurOfferApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        postOurOffer: build.mutation<IOurOffer, IPostOurOfferPayload>({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                try {
                    const payload = await appendTurnstileToken(body, TurnstileAction.OUR_OFFER_CONTACT);
                    const result = await baseQuery({
                        url: apiPath.our_offer,
                        method: "POST",
                        body: payload
                    });

                    if (result.error) {
                        return {error: result.error};
                    }

                    return {data: result.data as IOurOffer};
                } catch (_error) {
                    return {error: createTurnstileRtkError()};
                }
            }
        })
    })
});

export const {postOurOffer} = postOurOfferApi.endpoints;
export const {usePostOurOfferMutation} = postOurOfferApi;
